/* Black Friday editorial reveal: progressively enhanced, inert on other pages. */
(() => {
  'use strict';
  const motionQuery = window.matchMedia?.('(prefers-reduced-motion: reduce)');
  if (!('IntersectionObserver' in window) || motionQuery?.matches) return;

  let observer;
  const init = (root = document) => {
    if (!document.body.classList.contains('anania-bf')) return;
    const nodes = [];
    if (root.matches?.('.anbf-reveal:not([data-anbf-observed])')) nodes.push(root);
    root.querySelectorAll?.('.anbf-reveal:not([data-anbf-observed])').forEach(node => nodes.push(node));
    if (!nodes.length) return;
    if (!observer) {
      observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('anbf-in');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.01, rootMargin: '0px 0px 80px 0px' });
    }
    nodes.forEach(el => {
      if (el.getBoundingClientRect().top < window.innerHeight + 80) {
        el.classList.add('anbf-in');
      } else {
        observer.observe(el);
      }
      el.dataset.anbfObserved = 'true';
    });
    document.documentElement.classList.add('anbf-motion-ready');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
